import CentralApiService from "../../centralApiServices";


class CadastroProdutoService extends CentralApiService {

    constructor() {
        super('/api/cadastroProduto')
    }


    saveTipoProduto(tipoProduto){
        return this.post(`/saveTipoProduto`, tipoProduto)
    }

    deleteTipoProduto(tipoProdutoId){
        return this.delete(`/deleteTipoProduto/${tipoProdutoId}`)
    }

    saveTipoEstoque(tipoEstoque){
        return this.post(`/saveTipoEstoque`, tipoEstoque)
    }

    deleteTipoEstoque(tipoEstoqueId){
        return this.delete(`/deleteTipoEstoque/${tipoEstoqueId}`)
    }

    editBuyProduct(buyProduct){
        return this.put(`/editBuyProduct`, buyProduct)
    }

    getLancamentosProdutosIndividuaisUnificado(dataInicial, dataFinal, descricaoProdutosFiltradosList){
        let params = `?`
        params = `${params}&dataInicial=${dataInicial}`
        params = `${params}&dataFinal=${dataFinal}`
        return this.post(`/getLancamentosProdutosIndividuaisUnificado${params}`, descricaoProdutosFiltradosList)
    }        

}

export default CadastroProdutoService